<template>
  <div class="pt-4">
    <v-card>
      <v-row
        class="
          d-flex
          justify-end
          align-center
          pa-3
          mb-4
        "
        no-gutters
      >
        <v-col cols="12" md="6">
          <CreateNewCampaignDialog
            :fetchAffiliateCampaigns="fetchAffiliateCampaigns"
          />
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
            dense
            solo-inverted
            clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="campaignsList"
        :search="search"
        class="elevation-1"
        calculate-widths
        :loading="fetchingCampaigns"
        :loading-text="$t('loading')"
        :no-data-text="$t('noDataForthisQuery')"
        :header-props="headerProps"
        :footer-props="{
          'items-per-page-text': $t('rowsPerPage'),
          'items-per-page-options': [5, 10, 15],
        }"
      >
        <template v-slot:item.id="{ item }">
          <v-btn
            x-small
            @click="$copy(item.id)"
            style="text-transform: none;"
          >
            {{ item.id }}
          </v-btn>
        </template>

        <template v-slot:item.link="{ item }">
          <v-btn
            x-small
            @click="$copy(item.link)"
            style="text-transform: none;"
          >
            <span
              class="text-truncate"
              style="max-width: 200px;"
            >
              {{ item.link }}
            </span>
          </v-btn>
        </template>

        <template v-slot:item.campaign_code="{ item }">
          <v-btn
            x-small
            @click="$copy(item.campaign_code)"
          >
            {{ item.campaign_code }}
          </v-btn>
        </template>

        <template v-slot:item.channel="{ item }">
          {{ handleChannelOthers(item.channel) }}
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip small :color="handleStatusUI(item.status).color">
            {{ handleStatusUI(item.status).text }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{item}">
          <v-menu
            offset-y
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :key="item.id"
                small
                v-bind="attrs"
                v-on="on"
                :loading="settingCampaignStatus && disabledButtons.includes(item.id)"
                :disabled="disabledButtons.includes(item.id)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(action, i) in actions"
                :key="i"
                link
                @click="setCampaignStatus(item.id, action.status)"
                :disabled="action.status == item.status"
              >
                <v-icon
                  :color="handleActionsColor(action.status)"
                  x-small
                  left
                >
                  mdi-circle
                </v-icon>
                <v-list-item-title>
                  {{ action.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import CreateNewCampaignDialog from "@/views/dashboard/agent/campaigns/CreateNewCampaignDialog.vue";
export default {
  components: {
    CreateNewCampaignDialog
  },
  data: (vm) => ({
    valid: false,
    settingCampaignStatus: false,
    fetchingCampaigns: false,
    type: "",
    search: "",
    headerProps: {
      sortByText: vm.$t("sortBy")
    },
    actions: [
      {
        text: vm.$t("affiliateCampaign.deactivate"),
        status: 0,
      },
      {
        text: vm.$t("affiliateCampaign.activate"),
        status: 1,
      },
    ],
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "URL",
        value: "link",
      },
      {
        text: vm.$t("affiliateCampaign.campaignCode"),
        value: "campaign_code",
        align: "no-wrap",
      },
      {
        text: vm.$t("affiliateCampaign.name"),
        value: "campaign_name",
        align: "no-wrap",
      },
      {
        text: vm.$t("affiliateCampaign.numberOfClicks"),
        value: "quantity_link_clicks",
        align: "no-wrap",
      },
      // {
      //   text: vm.$t("affiliateCampaign.betQty"),
      //   value: "bet_quantity",
      //   align: "no-wrap",
      // },
      {
        text: vm.$t("affiliateCampaign.usersQty"),
        value: "quantity_users",
        align: "no-wrap",
      },
      // {
      //   text: vm.$t("affiliateCampaign.firstDepositQty"),
      //   value: "quantity_first_deposits",
      //   align: "no-wrap",
      // },
      {
        text: vm.$t("affiliateCampaign.socialMedia"),
        value: "channel",
        align: "no-wrap",
      },
      {
        text: "Status",
        value: "status",
        align: "no-wrap",
      },
      {
        text: vm.$t("actions"),
        value: "actions",
        align: "no-wrap",
      },
    ],
    campaignsList: [],
    disabledButtons: [],
  }),
  mounted() {
    this.fetchAffiliateCampaigns();
  },
  methods: {
    fetchAffiliateCampaigns() {
      this.fetchingCampaigns = true;
      this.$axios
        .get("/agent/affiliateCampaign/listAfilliateCampaign")
        .then((resp) => {
          this.campaignsList = resp.data.dados;
          this.campaignsList.reverse();
        })
        .catch(() => {
          this.campaignsList = [];
        })
        .finally(() => {
          this.fetchingCampaigns = false;
        });
    },
    setCampaignStatus(id, status) {
      this.disabledButtons.push(id);
      this.settingCampaignStatus = true;
      const body = {
        id,
        status
      };
      this.$axios
        .post(
          "/agent/affiliateCampaign/activateAndInactivateAfiliateCampaign",
          this.$formdata(body)
        )
        .then((resp) => {
          if (resp.status === 200) {
            this.$store.commit("setNotification", {
              msg: resp.data.messages,
              color: "success",
            });
            
            this.fetchAffiliateCampaigns()
          }
        })
        .catch(() => {})
        .finally(() => {
          this.settingCampaignStatus = false,
          this.disabledButtons.pop(id);
        })
    },
    handleStatusUI(status) {
      if (status == "1") {
        return { text: this.$t("active"), color: "green" };
      } else {
        return { text: this.$t("inactive"), color: "blue-grey" };
      }
    },
    handleActionsColor(value) {
      if (value == "1") {
        return "green";
      } else {
        return "blue-grey";
      }
    },
    handleChannelOthers(value) {
      return value == 'Others' ? this.$t("affiliateCampaign.others") : value;
    }
  },
};
</script>
<style>
.truncate {
  max-width: 400px;
}
</style>